import { get, put } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getList = async (listId) => {
  const builder = new UrlBuilder(`/assessments/get-list`);
  builder.add('listId', listId);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateList = async (payload) => {
  const builder = new UrlBuilder(`/documents/update-list`);

  try {
    const response = await put(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getStatusOfProcessing = async (listId) => {
  const builder = new UrlBuilder(`/assessments/get-status/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const generateReport = async (assessmentListId) => {
  const builder = new UrlBuilder(`/assessments/generate-report/${assessmentListId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
